const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '10年', label: '行业深耕' },
  { value: '200万+', label: '日访问量' },
  { value: '99.9%', label: '数据准确率' },
];

const partners = [
  '国家体育总局体育彩票管理中心',
  '中国福利彩票发行管理中心',
  '中国互联网彩票协会',
  '国家信息安全测评中心',
];

const certifications = [
  '信息安全等级保护三级认证',
  'ISO 27001信息安全管理体系认证',
  '可信网站认证',
  '企业信用评价AAA级',
];

export default function ReputationSection() {
  return (
    <section className="py-10">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center">
          信誉资质
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          彩客网以专业和诚信赢得行业认可
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mt-8">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center"
            >
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-building-4-line text-primary-500"></i> 合作伙伴
            </h4>
            <div className="flex flex-col gap-3">
              {partners.map((p, idx) => (
                <div key={idx} className="flex items-center gap-3 text-sm text-foreground-600">
                  <i className="ri-checkbox-circle-line text-accent-500"></i>
                  {p}
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-award-line text-accent-500"></i> 资质认证
            </h4>
            <div className="flex flex-col gap-3">
              {certifications.map((c, idx) => (
                <div key={idx} className="flex items-center gap-3 text-sm text-foreground-600">
                  <i className="ri-shield-check-line text-accent-500"></i>
                  {c}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}